// extracted by mini-css-extract-plugin
export default {"alertContainer":"AlertProvider_alertContainer__COlbR","container":"AlertProvider_container__Dc-1X"};